import { useEffect } from "react";
import { useLocation } from "react-router-dom";

interface Props {
    mode: string;
}

const ScrollToTopForService: React.FC<Props> = ({ mode }) => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "auto", 
        });
    }, [pathname, mode]); 

    return null;
};

export default ScrollToTopForService;